import React from 'react'
import SchoolIcon from '@mui/icons-material/School'

import MediaModal from './MediaModal'
import { CourseModalStyle } from '../styles'

const config = {
    Icon: SchoolIcon,
    style: CourseModalStyle,
    favouriteType: 'course',
    resourcePath: 'courses',
    authorsLabel: 'Instructor(s):',
    subKey: 'sub_courses',
    subHeading: 'Lessons',
    rowKeyPrefix: 'lesson',
}

const CourseModal = (props) => <MediaModal config={config} {...props} />

export default CourseModal
